import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavParams } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-konfirmasi-hapus',
  templateUrl: './konfirmasi-hapus.component.html',
  styleUrls: ['./konfirmasi-hapus.component.scss'],
})
export class KonfirmasiHapusComponent implements OnInit {

  image: any = '';
  title: any = '';
  desc: any = '';
  button: any = '2';
  btnTxt1: any = '';
  btnTxt2: any = '';

  titlePrimaryButton: any = '';
  titleSecondaryButton: any = '';


  constructor(
    public api: ApiService,
    public route: Router,
    public navParams: NavParams
  ) { 
    this.image = this.navParams.data.image;
    this.title = this.navParams.data.title;
    this.desc = this.navParams.data.desc;
    this.button = this.navParams.data.button;
    this.btnTxt1 = this.navParams.data.btnTxt1;
    this.btnTxt2 = this.navParams.data.btnTxt2;
    this.titlePrimaryButton = this.navParams.data.titlePrimaryButton || 'Ya, saya yakin';
    this.titleSecondaryButton = this.navParams.data.titleSecondaryButton || 'Batalkan';
  }

  ngOnInit(
    
  ) {}

  dismiss() {
    this.api.dismiss()
  }

  confirm() {
    // this.api.dismiss();
    // this.nav('')
    this.api.dismissData('','confirm')
  }

  nav(p: any) {
    this.route.navigate([p]);
  }

}